/**
 * Created by Florin David on 30/06/2020.
 */

import Action, {
  SET_FETCHING_RESPONSE,
  SET_RESPONSE,
} from 'constants/action-types'

/**
 * Generic errors
 */
export default (state = {}, action: Action): QueryResponse => {
  switch (action.type) {
    case SET_RESPONSE:
      return action.payload
    case SET_FETCHING_RESPONSE:
      return action.payload ? {} : state
    default:
      return state
  }
}
